import type { ESignatureValue } from "ui2";
import { Button, Input } from "ui2";

import { isSignatureReady, SignatureField } from "safety/components/attendance/SignatureField";
import { SubScreenHeader } from "safety/components/attendance/SubScreenHeader";

type VisitorScreenProps = {
  meetingName: string;
  visitorName: string;
  signature: ESignatureValue;
  submitting: boolean;
  onVisitorNameChange: (name: string) => void;
  onSignatureChange: (value: ESignatureValue) => void;
  onBack: () => void;
  onSubmit: () => void;
};

export const VisitorScreen = ({
  meetingName,
  visitorName,
  signature,
  submitting,
  onVisitorNameChange,
  onSignatureChange,
  onBack,
  onSubmit,
}: VisitorScreenProps): React.JSX.Element => (
  <>
    <SubScreenHeader meetingName={meetingName} onBack={onBack} />
    <div className="tw:flex tw:w-full tw:flex-1 tw:flex-col tw:gap-4 tw:p-5">
      <h1 className="tw:m-0 tw:text-2xl tw:font-denim tw:text-midnight">Who are you?</h1>
      <Input
        label="Full name"
        value={visitorName}
        autoFocus
        onChange={(event) => onVisitorNameChange(event.target.value)}
      />
      <div className="tw:border-t tw:border-stroke tw:pt-4">
        <SignatureField value={signature} onChange={onSignatureChange} />
      </div>
      <div className="tw:mt-auto tw:pt-2">
        <Button
          size="lg"
          className="tw:w-full tw:sm:w-auto"
          disabled={!visitorName.trim() || !isSignatureReady(signature) || submitting}
          onClick={onSubmit}
        >
          Submit attendance
        </Button>
      </div>
    </div>
  </>
);
